import type { ISEOProps } from "../types/core";

export const BookmarkedPostsPageSEO: ISEOProps = {
  title: "My Bookmarks - Sugar Cribs",
  description:
    "Manage your bookmarked posts on Sugar Cribs. View and organize your saved content collections.",
};
